import { Container } from "react-bootstrap";
import IntegrateForm from "../../components/Integrate-form";
import { useState, useEffect } from "react";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLazyGetShopCategoriesQuery, useCreateShopMutation } from "../../features/shop/shopApiSlice";

const ServiceIntegrateform = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [shopCategoryone, setShopCategoryone] = useState();
  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const imageUrl = useSelector((state) => state.imgurl);
  const [integrateshop, setIntegrateshop] = useState({
    userid: name._id,
    shopaddress: "",
    shopUrl: "",
    isIntegrated: true,
    image: [""],
    shopCategory: "",
    description: "",
    status: true,
  });

  useEffect(() => {
    setIntegrateshop((integrateshop) => ({
      ...integrateshop,
      image: imageUrl?.imgurl || "",
    }));
    // ...
  }, [imageUrl]);
  const [data, setData] = useState({
    category: "",
  });

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = data?.category[1];
  const categoryid = data.category[0];

  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [createShopMutation] = useCreateShopMutation();

  useEffect(() => {
    getShopCategories({ type: 'services', parentCategory: '' }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategory(response?.data?.Category);
        }
      })
      .catch((error) => { });
  }, []);


  const Mydata = () => {
    getShopCategories({ type: 'services', parentCategory: categoryName }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategorytwo(response?.data?.Category);
        }
      })
      .catch((error) => { });
  };


  const HandlePost = async () => {
    try {
      const response = await createShopMutation(integrateshop).unwrap();
      if (response?.success) {
        SuccessNotify("Shop Integrated Successfully");
        navigate("/wholeseller-integrate-form");
      }
    } catch (error) {
      FailedNotify("Failed to create Try Again!");
    }
  };

  return (
    <>
      <Container>
        <div className="screenHeight">
          <IntegrateForm backurl="/service-integrate" shopCategorytwo={shopCategorytwo} setIntegrateshop={setIntegrateshop} shopCategory={shopCategory} HandlePost={HandlePost} Mydata={Mydata} Handledata={Handledata} />
        </div>
      </Container>
    </>
  );
};

export default ServiceIntegrateform;